React = require 'react'
t = require('views/internal/recup-with-helpers')('enterprise_dashboard_join_request_component')

module.exports = class extends React.Component
  _hasEnoughLicenses: ->
    @props.joinRequest.transferability.newBillableMembers?.length <= @props.availableLicenses

  _renderManyMembers: t.renderable ->
    { joinRequest } = @props
    { organization } = joinRequest

    if joinRequest.transferability.newBillableMembers.length > 0
      translationKey = if organization.membershipCount < 5
          switch joinRequest.transferability.newBillableMembers.length
            when 1 then 'request-user-count-2-to-4-has-1-new'
            when 2, 3, 4 then 'request-user-count-2-to-4-has-new-count-2-to-4'
            else 'request-user-count-2-to-4-has-new-count-many'
        else
          switch joinRequest.transferability.newBillableMembers.length
            when 1 then 'request-user-count-other-has-1-new'
            when 2, 3, 4 then 'request-user-count-other-has-new-count-2-to-4'
            else 'request-user-count-other-has-new-count-many'

      t.format translationKey, {
        current: organization.membershipCount
        new: joinRequest.transferability.newBillableMembers.length
      }
    else
      translationKey = if organization.membershipCount < 5
          'request-with-many-users-all-in-enterprise-count-2-to-4'
        else
          'request-with-many-users-all-in-enterprise-count-other'

      t.format translationKey,
        current: organization.membershipCount

  _renderMemberCount: t.renderable ->
    { joinRequest } = @props
    { organization } = joinRequest

    if organization.membershipCount == 1
      if joinRequest.transferability.newBillableMembers.length > 0
        t.format 'request-user-count-1-not-in-enterprise'
      else
        t.format 'request-user-count-1-is-in-enterprise'
    else
      @_renderManyMembers()

  _renderTransferrable: t.renderable ->
    if @_hasEnoughLicenses()
      @_renderMemberCount()
    else
      if @props.availableLicenses?
        licensesNeeded = @props.joinRequest.transferability.newBillableMembers.length - @props.availableLicenses

        key = switch licensesNeeded
          when 1 then 'not-enough-licenses-one'
          when 2, 3, 4 then 'not-enough-licenses-2-to-4'
          else 'not-enough-licenses-many'

        t.format key, { licensesNeeded }
      else
        @_renderMemberCount()
        t.br()
        t.text "You don't have enough licenses to add this team."

  render: t.renderable ->
    {
      onViewUntransferredMembers,
      onViewNewBillableMembers,
      onDecline,
      onAccept,
      joinRequest,
      availableLicenses
    } = @props
    { organization } = joinRequest

    classes = t.classify
      'non-transferrable': !joinRequest.transferability.transferrable
      'not-enough-licenses': !@_hasEnoughLicenses()
    t.div '.dashboard-list-item.join-request', class: classes, =>
      t.div '.options', =>
        t.b (el) ->
          onDecline(el, joinRequest)
        , ".option.button-link.role-button", ->
          t.format 'decline'

        if joinRequest.transferability.transferrable
          t.b (el) =>
            onAccept(el, joinRequest)
          , ".option.button-link.role-button"
          , class: t.classify(disabled: !@_hasEnoughLicenses())
          , disabled: !@_hasEnoughLicenses()
          , ->
            t.format 'accept'

      t.div '.member', ->
        if organization.logoHash
          t.img '.member-avatar', src: [logoDomain, organization.logoHash, '30.png'].join('/')
        else
          t.span '.team-of-member-image.icon-lg.icon-organization'

      t.div '.details', =>
        t.p '.name-line', ->
          t.span '.full-name', ->
            t.text organization.displayName
        t.p '.u-bottom.quiet', =>
          t.span '.quiet.u-inline-block', =>
            if joinRequest.transferability.transferrable
              if joinRequest.transferability.newBillableMembers.length > 0
                t.b (el) =>
                  onViewNewBillableMembers(el, joinRequest)
                , =>
                  @_renderTransferrable()
              else
                @_renderTransferrable()
            else
              t.b (el) ->
                onViewUntransferredMembers(el, joinRequest)
              , ".option.quiet.non-transferrable-request", ->
                t.format 'non-transferrable-users'



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/join-request-component.coffee